import { useRef, useState } from "react";

import { CONFIRM_ERROR_FALLBACK } from "@/ds";
import {
  ATIVAR_LABEL,
  INATIVAR_LABEL,
  O_QUE_ACONTECE_TITLE,
} from "./confirmar-situacao-dialog.constants";
import type {
  ConfirmarSituacaoDialogProps,
  ConfirmarSituacaoDialogViewModel,
} from "./types-confirmar-situacao-dialog";

const mensagemDoErro = (falha: unknown): string =>
  falha instanceof Error && falha.message ? falha.message : CONFIRM_ERROR_FALLBACK;

export function useConfirmarSituacaoDialog({
  acao,
  titulo,
  subtitulo,
  oQueAcontece,
  corpo,
  campos,
  confirmLabel,
  tituloEfeitos,
  onConfirmar,
  onCancelar,
}: ConfirmarSituacaoDialogProps): ConfirmarSituacaoDialogViewModel {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [erro, setErro] = useState<string | null>(null);
  const emCurso = useRef(false);
  const inativando = acao === "inativar";

  return {
    tom: inativando ? "danger" : "success",
    titulo,
    subtitulo,
    oQueAcontece,
    tituloEfeitos: tituloEfeitos ?? O_QUE_ACONTECE_TITLE,
    corpo,
    campos,
    confirmarLabel: confirmLabel ?? (inativando ? INATIVAR_LABEL : ATIVAR_LABEL),
    erro,
    isSubmitting,
    confirmar: async () => {
      if (emCurso.current) return;
      emCurso.current = true;
      setErro(null);
      setIsSubmitting(true);
      try {
        await onConfirmar();
      } catch (falha) {
        setErro(mensagemDoErro(falha));
      } finally {
        emCurso.current = false;
        setIsSubmitting(false);
      }
    },
    cancelar: () => {
      if (!emCurso.current) onCancelar();
    },
  };
}
